import React, { useContext } from 'react'
import { SharedCampaignContext } from '../../../../../contexts/Advertiser/SharedCampaignContext'

export default function General({ campaignName }) {
  const { campaign } = useContext(SharedCampaignContext)

  return (
    <div className='w-full h-full bg-white dark:bg-rb-dark-mode border-1 border-rb-widget-border dark:border-rb-dark-mode-lighter rounded-lg p-4'>
      <h1 className='font-bold text-xl py-2 dark:text-white'>General</h1>
      <p className='text-xs dark:text-gray-400'>
        Name of the campaign
      </p>
      <p className='text-lg font-bold mb-2 dark:text-white'>{campaignName}</p>
      <div className='p-3 border-1 border-rb-widget-border dark:border-rb-dark-mode-lighter rounded-md flex items-center'>
        <img src={campaign?.client_image} alt='' className='w-9 h-9 mr-4' />
        <div className='flex flex-col items-start justify-between'>
          <p className='text-xs dark:text-gray-400'>client</p>
          <p className='text-md font-bold dark:text-white'>{campaign?.client_name}</p>
        </div>
      </div>
    </div>
  )
}